import {combineReducers} from 'redux';
import initData from './initReducer';
import contentData from './contentDataReducer';
import trackingData from './trackingDataReducer';
import userData from './userDataReducer';
import titles from './titleReducer';
import navigation from './navigationReducer';
import dialogPopup from './dialogReducer';
import displayMainMenu from './mainMenuReducer';
import displayResources from './resourcesReducer';
import displayNotes from './notesReducer';
import resourceProps from './resourcesPropsReducer';
import contentToolTip from './contentToolTipReducer';
import clickRevealDialog from './clickRevealDialogReducer';
import assetDialog from './assetDialogReducer';
import audio from './audioReducer';
import fontSize from './fontSizeReducer';
import screenDialog from './screenDialogReducer';
import ajaxCallsInProgress from './ajaxStatusReducer';

const rootReducer = combineReducers({
	//es6 short hand property name
	initData,
	contentData,
	trackingData,
	userData,
	dialogPopup,
	titles,
	navigation,
	ajaxCallsInProgress,
    displayMainMenu,
    displayResources,
    displayNotes,
	resourceProps,
	contentToolTip,
	clickRevealDialog,
    assetDialog,
    screenDialog,
    audio,
    fontSize
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/